require('./bootstrap');
require('./calendar');
require('./scripts');

var Isotope = require('isotope-layout');

const Swal = require('./sweetalert2.all.min');
//import Alpine from 'alpinejs';

//window.Alpine = Alpine;

//Alpine.start();

document.addEventListener("DOMContentLoaded", function() {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy"));

    if ("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    $this = $(entry.target);
                    $this.css('background-image',"url("+$this.attr('data-background')+")");
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }
});

var interval;

window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted ||
        ( typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2 );
    if ( historyTraversal ) {
        // Handle page restore.
        location.reload();
    }
});
var trans = {};
var api = {
    loading : function()
    {
        $('.loading-overlay').show();
    },
    done : function(){
        $('.loading-overlay').hide();
    },
    toast: function(type, title)
    {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: title,
            showConfirmButton: false,
            //backdrop:false,
            toast:true,
            timer:1500
        })
    },
    message: function(type, title, confirmText)
    {
        Swal.fire({
            icon: type,
            title: '',
            html: title,
            showConfirmButton: true,
            confirmButtonText: confirmText,
            //backdrop:false,
            //timer:1500
        })
    },
    delete_cookie: function (name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    setCookie: function(cname, cvalue, hours) {
        var d = new Date();
        d.setTime(d.getTime() + (hours*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    submitForm : function(form)
    {
        api.loading();
        return $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            dataType: 'json',
            success : function(data){
                api.done();
                api.callback(data, form);
                //api.message(data.message_type,data.message);
            },
            error : function(xhr, ajaxOptions, thrownError){
                api.done();
                console.log(xhr);
                api.error(trans.check_required_fields);
            }
        }).done(function(){
            api.done();
        });
    },
    callback : function(data, form)
    {
        if(form.attr('id') == 'review_form')
        {
            if(typeof(data.status.id) !=='undefined')
            {
                var modal = form.parents('.modal');
                $('input[name="name"],textarea',form).val('');

                $('.modal-title, .modal-footer',modal).html('');

                $('.success',modal).removeClass('d-none');

                $('.modal-body',modal).html($('.success',modal));

                api.loading();

                setTimeout(function(){
                    location=data.redirect;
                },1000);

                //bs.Modal.getInstance(document.querySelector('#review_modal')).hide();
            }
            else{
                if(typeof(data.message) !=='undefined')
                {
                    api.error(data.message);
                }
                else{
                    api.error(trans.check_required_fields);
                }
            }
        }

        if(form.hasClass('addToCartForm'))
        {
            if(data.status)
            {
                $('input[name="quantity"]',form).val(1);
                $('.options .option input',form).prop('checked',false);
                $('.options-groups input',form).prop('checked',false);
                $('.options .option',form).removeClass('active');
                $('.add-to-cart .info span',form).html($('.add-to-cart .info',form).attr('data-base-price')+"&euro;")

                $('.cart-info .count',).html(data.count);
                $('.cart-info .amount').html(data.total+"&euro;")
                $('.cart-info').removeClass('d-none');

                if(data.product_type == 'paint_order_product')
                {
                    $('.js-paint-job').removeClass('d-none');

                    $('.js-paint-job').attr('href',data.paint_job_link);
                }
                else{
                    $('.js-paint-job').addClass('d-none');
                }

                $('#add_to_cart_modal .product-quantity').html(data.product_quantity);
                $('#add_to_cart_modal .product-price').html(data.product_price+"&euro;");
                $('#add_to_cart_modal .product-img').css('background-image',"url('"+data.product_image+"')");
                $('#add_to_cart_modal .product-title').html(data.product_name);

                if(data.product_display_option.length)
                {
                    $('#add_to_cart_modal .product-display-option').html(data.product_display_option);
                }
                else{
                    $('#add_to_cart_modal .product-display-option').hide();
                }

                if(data.product_options.length)
                {
                    $('#add_to_cart_modal .product-options').html(data.product_options);
                }

                if(form.hasClass('paintjob-item'))
                {
                    $('.paintjob-item').addClass('d-none');
                    $('.js-success-info').removeClass('d-none');
                    $('.step.active').addClass('done');
                    $('#add_to_cart_modal .product-price').html(data.product_price+"&euro; / "+data.product_display_option);
                    $('#add_to_cart_modal .product-display-option').hide();
                    $('#add_to_cart_modal .product-quantity').parent().html('<span class="product-quantity">'+data.product_quantity+' '+data.product_display_option+'</span>');
                }

                bs.Modal.getOrCreateInstance(document.querySelector('#add_to_cart_modal')).show();

                if(typeof interval !== undefined)
                {
                    clearInterval(interval);
                }
                $('#time').attr('data-time', data.time);
                api.timer($('#time'));
            }
            else{
                api.error(data.message);
            }
        }
    },
    search : function(value)
    {
        $.ajax({
            type: 'GET',
            url: $('.js-search').data('url'),
            data: {
                'search' : value
            },
            dataType: 'html',
            success : function(html){
                $('#search-results').html(html);

                if($(document).find('#search-results .item').length)
                {
                    $('.tag-cloud').hide();
                }
                else{
                    $('.tag-cloud').show();
                }

                if($('.js-search').val().length < 3)
                {
                    $('.tag-cloud').show();
                }
            },
            error : function(xhr, ajaxOptions, thrownError){
                //api.error(xhr, ajaxOptions, thrownError);
            }
        });
    },
    addToCart : function(){

    },
    timer : function(display){
        var time = display.attr('data-time');
        var parts = time.split(":");

        var duration = (parseInt(parts[0]) * 60)+parseInt(parts[1]);

        if(duration == 0)
        {
            $('.notification.cart-info').addClass('d-none');
            this.clearCart($('.notification.cart-info').parent().attr('data-url'), false);
        }

        startTimer(duration, display);
    },
    extendCart : function(url){
        $.ajax({
            type: 'GET',
            url: url,
            data: {
                'extend' : 1
            },
            dataType: 'json',
            success : function(data){
                location.reload();
            }
        });
    },
    clearCart : function(url, reload = true){
        $.ajax({
            type: 'GET',
            url: url,
            data: {
                'clear' : 1
            },
            dataType: 'json',
            success : function(data){
                $('.notification.cart-info').addClass('d-none');
                if(reload)
                {
                    location.reload();
                }
            }
        });
    },
    getPageModal : function(url){
        var modal = $('#page_modal');

        $.ajax({
            type: 'GET',
            url: url,
            data: {
                'modal' : 1
            },
            dataType: 'html',
            success : function(html){
                $('.modal-content',modal).html(html);

                bs.Modal.getOrCreateInstance(document.querySelector('#page_modal')).show();
            }
        });
    },
    error: function(text)
    {
        Swal.fire({
            title: '',
            text: text,
            icon: 'error',
            timer: 3000,
            showConfirmButton:false
        });
    },
    init: function(){
        $.ajax({
            type: 'GET',
            url: $('input[name="js_trans_url"]').val(),
            data: {},
            dataType: 'json',
            success : function(json){
                trans = json;
            },
            error : function(xhr, ajaxOptions, thrownError){
                api.toast('error',thrownError);
            }
        });

        var stickyTop = $('.sticky-top');
        var lastScrollTop = 0;
        if(stickyTop.length)
        {
            var stickyTopElPosition = stickyTop.offset().top;
            $(window).on('scroll',function(){
                var st = $(this).scrollTop();

                if (st < stickyTopElPosition) {
                    stickyTop.removeClass("active")
                }

                if(st > 100)
                {


                    if (st > lastScrollTop){
                        stickyTop.removeClass("fadeInDown");
                        stickyTop.addClass('fadeOut');
                    } else{
                        stickyTop.removeClass('fadeOut')
                        stickyTop.addClass("active animated fast fadeInDown");
                    }
                }

                lastScrollTop = st;
            });
        }

        var message = $('.js-message');

        if(message.length)
        {
            if(message.attr('data-modal'))
            {
                this.message(message.attr('data-type'),message.html(), message.attr('data-confirm-text'));
            }
            else{
                this.toast(message.attr('data-type'),message.html());
            }
        }
    }
}

function reviewCallback(data)
{
    console.log(data)
}

function startTimer(duration, display) {
    var start = Date.now(),
        diff,
        minutes,
        seconds;
    function timer() {
        // get the number of seconds that have elapsed since
        // startTimer() was called
        diff = duration - (((Date.now() - start) / 1000) | 0);

        // does the same job as parseInt truncates the float
        minutes = (diff / 60) | 0;
        seconds = (diff % 60) | 0;

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $('span',display).html(minutes + ":" + seconds);

        if (diff <= 0) {
            // add one second so that the count down starts at the full duration
            // example 05:00 not 04:59
            start = Date.now() + 1000;
        }

        if($('span',display).html() == "00:00"){

            if(display.data('modal') == 'extend_cart_modal')
            {
                clearInterval(interval);
                location.reload(true);
            }

            if(display.attr('id') == 'time')
            {
                clearInterval(interval);
                if ($('#extend_cart_modal').length)
                {
                    bs.Modal.getOrCreateInstance(document.querySelector('#extend_cart_modal')).show();

                    api.timer($('#modal_time'));
                }
            }
        }
    };
    // we don't want to wait a full second before the timer starts
    timer();
    interval = setInterval(timer, 1000);
}

$(document).ready(function(){

    api.init();

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bs.Tooltip(tooltipTriggerEl)
    })

    if($('#js-color-type').length)
    {
        $('#js-color-type').on('change',function(){
           $('.colors-list .colors').removeClass('active');
            $('.colors-list .colors[data-type="'+$(this).val()+'"]').addClass('active');
        });
    }

    var mouseOverMenu = false;

    $(document).on('click','.disabled-overlay',function(e){
        api.error($(this).attr('data-message'));
    });

    $(document).on('click','.js-alert-message',function(e){
        e.preventDefault();

        var url = $(this).attr('href');

        Swal.fire({
            text: $(this).attr('data-message'),
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: trans.ok,
            denyButtonText: trans.cancel,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                api.loading();

                location=url;
            } else if (result.isDenied) {

            }
        });
    })

    $(document).on('mouseover','.menu-items .menu-item',function(e){
        mouseOverMenu = true;
        $('.menu-item-content .item-content').removeClass('active');
        $('.menu-items .menu-item.active').removeClass('active');
        if($('.menu-item-content .item-content[data-id="'+$(this).data('id')+'"] a').length)
        {
            $(this).addClass('active');
            $('.menu-item-content .item-content[data-id="'+$(this).data('id')+'"]').addClass('active');
        }
    });

    $(window).click(function() {
        $('.menu-item-content .item-content').removeClass('active');
        $('.menu-items .menu-item.active').removeClass('active');
    });

    $('.menu-item-content .item-content').click(function(event){
        event.stopPropagation();
    });


    $(document).on('click','.day',function(e){
        e.preventDefault();
        $('.day').removeClass('active');

        $('.day[data-date="'+$(this).attr('data-date')+'"]').addClass('active');

        $('input[name="date"]').val($(this).attr('data-date'));

        $.ajax({
            type: 'GET',
            url: $('.calendar').attr('data-url'),
            data: {
                'product_id' : $(this).attr('data-product-id'),
                'date' : $(this).attr('data-date')
            },
            dataType: 'html',
            success : function(html){
                $('.calendar-wrapper').html(html);

                var date = $('input[name="date"]').val();

                $('.day').removeClass('active');
                $('.day[data-date="'+date+'"]').addClass('active');

                if($('.times .time').length)
                {
                    $('.add-to-cart').removeClass('d-none');

                    if($('.add-to-cart').data('stop-sale') == 0)
                    {
                        $('.add-to-cart').removeClass('disabled');
                    }
                }
                else
                {
                    $('.add-to-cart').addClass('d-none');
                }

                if(parseInt($('.add-to-cart .count').html()) > 0)
                {
                    $('.add-to-cart').parent().removeClass('d-none');
                }
            }
        });

    });

    $(document).on('click','.month',function(e){
        e.preventDefault();
        $.ajax({
            type: 'GET',
            url: $('.calendar').attr('data-url'),
            data: {
                'product_id' : $(this).attr('data-product-id'),
                'date' : $(this).attr('data-date')
            },
            dataType: 'html',
            success : function(html){
                $('.calendar-wrapper').html(html);

                var date = $('input[name="date"]').val();

                $('.day').removeClass('active');
                $('.day[data-date="'+date+'"]').addClass('active');
            }
        });

    });

    $(document).on('click','.js-link',function(e){
        api.loading();
        location=$(this).attr('data-url');
    });

    $(document).on('click','.time',function(e){
        e.preventDefault();
        $('.time').removeClass('active');
        $(this).addClass('active');

        $('input[name="time"]').val($(this).attr('data-time'));

    });

    $(document).on('click','.js-calendar',function(e){
        e.preventDefault();
        if($(this).attr('data-action') == 'more')
        {
            $('.calendar-row.days.main').addClass('d-none');
            $(this).hide();
            $('.calendar-rows-wrapper').removeClass('d-none');
        }
        else{
            $('.calendar-row.days.main').removeClass('d-none');
            $('.calendar-rows-wrapper').addClass('d-none');
            $('.js-calendar[data-action="more"]').show();
        }
    });

    $('.js-modal-page').on('click',function(e){
        e.preventDefault();

        api.getPageModal($(this).attr('href'));
    })

    $('.options .option').on('click',function(){
        if(!$(this).hasClass('disabled'))
        {
            var input = $('input',$(this));
            input.prop("checked", !input.prop("checked"));
            input.change();
            $(this).toggleClass('active');
        }
    });

    function updatePrice(el)
    {
        var parent = el.parents('form.addToCartForm');

        var price = parseFloat($('.add-to-cart .info',parent).attr('data-base-price'));

        $('.option input:checked',parent).each(function(){
            price += parseFloat($(this).attr('data-price')) - parseFloat($(this).attr('data-discount'));
        });

        $('.options-groups input:checked',parent).each(function(){
            price += parseFloat($(this).attr('data-price'));
        });

        $('.options-groups select',parent).each(function(){
            price += parseFloat($('option[value="'+$(this).val()+'"]',$(this)).attr('data-price'));
        });

        price = price * parseInt($('input[name="quantity"]',parent).val());

        price = price.toFixed(2);

        $('.add-to-cart .info span',parent).html(price+"&euro;");

        return price;
    }

    $('.option input input, .options-groups input, .options-groups select, input[name="quantity"]').on('change',function(){
        updatePrice($(this));
    });

    if($('#time').length && $('#time').attr('data-time').length && $('#time').attr('data-time') !== '00:00')
    {
        api.timer($('#time'));
    }

    $('.js-extend-cart-btn').on('click',function(e){
        e.preventDefault();
        api.extendCart($(this).attr('url'));
    });
    $('.js-cancel-cart-btn').on('click',function(e){
        e.preventDefault();
        api.clearCart($(this).attr('url'));
    });

    $(document).on('click','.js-example-item-remove',function(e){
        e.preventDefault();
        $(this).parents('p').remove();

        if($('.example-items p').length == 0) $('.example-items').removeClass('has-items');
    });

    $('#order-example-color-type').on('change',function(){
       var type = $(this).val();

       if(type.length)
       {
           $('#order-example-color option').prop('disabled', true);

           $('#order-example-color option[data-type="'+type+'"]').prop('disabled', false);
       }
       else{
           $('#order-example-color option').prop('disabled', false);
       }
    });

    $(document).on('click','.js-order-example-add',function(e){
        e.preventDefault();

        var profile = $('#order-example-profile').val();
        var color = $('#order-example-color').val();

        if(color.length == 0 && profile.length == 0){
            api.message('error',trans.select_color_or_profile,trans.confirm_btn_text);
            return false;
        }

        var index = $('.js-item').length ? (parseInt($('.js-item').last().attr('data-index')) + 1) : 0;

        var type = '';

        if(profile.length && color.length)
        {
            type = 'example_profile_plus_color'
        }
        else if(profile.length && color.length == 0)
        {
            type = 'example_profile'
        }
        else if(profile.length == 0 && color.length)
        {
            type = 'example_color'
        }

        var html = "";
        html += "<p class='js-item' data-index='"+index+"'>\n";
        html += '<input type="hidden" name="items['+index+'][type]" value="'+type+'"/>';
        html += '<input type="hidden" name="items['+index+'][name]" value="'+profile+' '+color+'"/>';
        html += '- '+profile+' '+color+'<a href="#" class="link-danger js-example-item-remove"><i class="bi bi-trash"></i></a>';
        html += "</p>";

        $('#order-example-profile').val('');
        $('#order-example-color').val('');
        $('#order-example-color-type').val('');
        $('#order-example-color option').removeAttr('disabled');

        $('.example-items').addClass('has-items');

        $('.example-items').append(html);
    })

    $('.js-show-remove-item-modal').on('click',function(e){
        e.preventDefault();
        $('#remove_item_modal .js-remove-from-cart').attr('href',$(this).attr('href'));
        $('#remove_item_modal .js-remove-from-cart').attr('data-uuid',$(this).attr('data-uuid'));

        if($('#cart_modal').hasClass('show'))
        {
            bs.Modal.getOrCreateInstance(document.querySelector('#cart_modal')).hide();
        }

        bs.Modal.getOrCreateInstance(document.querySelector('#remove_item_modal')).show();
    });

    $(document).on('click','.js-check-cart-modal',function(){
        if(!$('body').hasClass('cart-page'))
        {
            bs.Modal.getOrCreateInstance(document.querySelector('#cart_modal')).show();
        }
    });

    $(document).on('change','.js-city-select',function(e){
        $('input[name="price"]').val($(this).val());
    });

    $(document).on('click','#same_address',function(){
        $('.shipping-address').toggleClass('d-none');
        if($(this).is(':checked'))
        {
            $('.shipping-address input').val("");
            $('.shipping-address input').removeAttr('required');
        }
        else{
            $('.shipping-address input').attr('required','required');
        }
    });
    $(document).on('click','#invoice_required',function(){
        $('.company-fields').toggleClass('d-none');
        if($(this).is(':checked'))
        {
            $('.company-fields input.required').attr('required','required');
        }
        else{
            $('.company-fields input').val("");
            $('.company-fields input.required').removeAttr('required');
        }
    });



    $('.js-remove-from-cart').on('click',function(e){
        e.preventDefault();
        api.loading();
        location.href=$(this).attr('href');
        //e.preventDefault();
        //var item = $('.cart-item[data-uuid="'+$(this).attr('data-uuid')+'"]');
        //var linked_item = typeof item.attr('data-linked-uuid') !== 'undefined' && item.attr('data-linked-uuid').length ? $('.cart-item[data-uuid="'+item.attr('data-linked-uuid')+'"]') : false;



        /*$.ajax({
            type: 'GET',
            url: $(this).attr('href'),
            data: {},
            dataType: 'json',
            success : function(data){
                if(data.status)
                {
                    item.fadeOut().remove();

                    if(linked_item && linked_item.attr('data-type') == 'paint_order_service')
                    {
                        linked_item.fadeOut().remove();
                    }
                    else if(linked_item){
                        $('.js-paint-order-info',linked_item).remove();
                        $('.js-paint-order-btn',linked_item).removeClass('d-none');
                    }

                    if($('.cart-item').length)
                    {
                        var subtotal = parseFloat(data.cart.subtotal);
                        var tax = parseFloat(data.cart.tax);
                        var total = parseFloat(data.cart.total);

                        $('.cart-totals .subtotal').html(subtotal.toFixed(2)+"&euro;");
                        $('.cart-totals .tax').html(tax.toFixed(2)+"&euro;");
                        $('.cart-totals .total').html(total.toFixed(2)+"&euro;");
                    }
                    else{
                        $('.cart-items,.cart-totals').remove();
                        $('.empty-cart').removeClass('d-none');
                        window.location.href = '/';
                    }

                }
            },
            error : function(xhr, ajaxOptions, thrownError){
                //api.error(xhr, ajaxOptions, thrownError);
            }
        });*/
    });

    $('.payment-method').on('click',function(e){
        $('.payment-method').removeClass('active');
        $(this).addClass('active');
    });

    $('input[name="payment"]').on('change',function(e){
        var value = $(this).val();

        $('.payment-options').addClass('d-none');

        $('.payment-options[data-type="'+value+'"]').removeClass('d-none');
    });

    $('input[name="shipping_method"]').on('change',function(e){
        //var value = $(this).val();

        //$('.payment-options').addClass('d-none');

        //$('.payment-options[data-type="'+value+'"]').removeClass('d-none');

        //$('.js-payment-info-link').attr('href',$('.js-payment-info-link').attr('data-url')+'?shipping_method='+$(this).val());

        api.loading();

        location.href = $(this).attr('data-url');

    });

    $('.payment-options select[name="city"]').on('change',function(e){
        var shipping_method = $('input[name="shipping_method"]').val();

        $('.js-payment-info-link').attr('href',$('.js-payment-info-link').attr('data-url')+'?shipping_method='+shipping_method+'&city='+$('option:checked',$(this)).html());
    });

    $(document).on('click','#create_account',function(){
       $('.js-create-account-info').toggleClass('d-none');
    });

    $('.js-add-to-cart').on('click',function(e){
        e.preventDefault();

        /*var action = $(this).attr('data-action');

        if(typeof action !== "undefined" && action !== null)
        {
            var parent = $(this).parents('.js-item');
            var data = {
                "_token" : $('input[name="_token"]').val(),
                'quantity' : $('input[name="quantity"]',parent).val()
            }
            api.loading();
            return $.ajax({
                type: 'POST',
                url: action,
                data: data,
                dataType: 'json',
                success : function(data){
                    api.done();
                    api.callback(data, parent);
                    //api.message(data.message_type,data.message);
                },
                error : function(xhr, ajaxOptions, thrownError){
                    api.done();
                    console.log(xhr);
                    api.error(trans.check_required_fields);
                }
            }).done(function(){
                api.done();
            });
        }
        else{*/
            var form = $(this).parents('form.addToCartForm');

            api.submitForm(form, 'addToCarCallback');
        //}
    });

    $('#search_modal').on('show.bs.modal',function(e) {
        var $this = $(this);
        $('.js-search').val('').focus();
        $('#search-results').html('');
        $('.tag-cloud').show();
    });

    $('#search_modal').on('shown.bs.modal',function(e) {
        setTimeout(function (){
            $('.js-search').get(0).focus();
        }, 500);
    });

    $('.js-search').on('keyup', function(e) {

        if($(this).val().length > 2)
        {
            api.search($(this).val());
        }
        else{
            $('.tag-cloud').show();
        }
    });

    $('.js-qty').on('click',function(e){
        e.preventDefault();

        var input = $('input',$(this).parent());

        var value = $(this).data('type') == 'plus' ? parseInt(input.val()) + 1 : parseInt(input.val()) - 1;

        if(value < 0) value = 0;

        if(value > input.data('max')) value = input.data('max');
        if(value < input.data('min')) value = input.data('min');
        input.val(value);
        input.change();
    });

    $(document).on('change', 'input[name="quantity"]', function(){
        updatePrice($(this));
    });

    $(document).on('click','.radio-options tr',function(){

        var form = $(this).parents('.addToCartForm');

        $('input',form).removeAttr('checked');

        $('input',$(this)).prop('checked',true);

        var price = parseFloat($('.add-to-cart .info',form).attr('data-base-price'));

        console.log('base price: '+price);

        $('.option input:checked',form).each(function(){
            price += parseFloat($(this).attr('data-price')) - parseFloat($(this).attr('data-discount'));
        });

        $('.options-groups input:checked',form).each(function(){
            price += parseFloat($(this).attr('data-price'));
        });

        $('.options-groups select',form).each(function(){
            price += parseFloat($('option[value="'+$(this).val()+'"]',$(this)).attr('data-price'));
        });

        price = price * parseInt($('input[name="quantity"]',form).val());

        price = price.toFixed(2);

        $('.add-to-cart .info span',form).html(price+"&euro;");

        return price;
    });

    $('.js-tag').on('click',function(e){
        $('.js-search').val($(this).html()).keyup();
    });

    if($('.categories-slider').length)
    {
        $('.categories-slider').each(function(){
            var slides = $('.slide',$(this)).length;

            var width = 166 * slides;

            $('.overscroll-x').css('width',width+'px');
        });
    }

    $('.js-back').on('click',function(e){
        history.back();
    });

    $(document).on('click','#review_modal .rating .bi',function(e){
        var value = parseInt($(this).data('value'));

        $('#review_modal .rating .bi').each(function(){
            var v = parseInt($(this).attr('data-value'));
            if(value >= v){
                $(this).removeClass('bi-star').addClass('bi-star-fill');
            }
            else{
                $(this).removeClass('bi-star-fill').addClass('bi-star');
            }
        });
        $('input[name="rating"]',$('#review_modal')).val(value);
    });

    $(document).on('click','.js-add-review-submit',function(e){
        e.preventDefault();
        var form = $('#review_form');

        api.submitForm(form, 'reviewCallback');
    });

    if($('.categories-slider.desktop').length)
    {
        const slider = document.querySelector('.categories-slider.desktop .slides');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            e.preventDefault();
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
            console.log(walk);
        });
    }
});

var isRtl = $("html").attr("dir") === "rtl";
var $document = $(document);
var $window = $(window);
var $html = $("html");
var $body = $("body");

/**
 * getSwiperHeight
 * @description  calculate the height of swiper slider basing on data attr
 */
function getSwiperHeight(object, attr) {
    var val = object.attr("data-" + attr),
        dim;

    if (!val) {
        return undefined;
    }

    dim = val.match(/(px)|(%)|(vh)$/i);

    if (dim.length) {
        switch (dim[0]) {
            case "px":
                return parseFloat(val);
            case "vh":
                return $(window).height() * (parseFloat(val) / 100);
            case "%":
                return object.width() * (parseFloat(val) / 100);
        }
    } else {
        return undefined;
    }
}

/**
 * toggleSwiperInnerVideos
 * @description  toggle swiper videos on active slides
 */
function toggleSwiperInnerVideos(swiper) {
    var prevSlide = $(swiper.slides[swiper.previousIndex]),
        nextSlide = $(swiper.slides[swiper.activeIndex]),
        videos,
        videoItems = prevSlide.find("video");

    for(var i = 0; i < videoItems.length; i++) {
        videoItems[i].pause();
    }

    videos = nextSlide.find("video");
    if (videos.length) {
        videos.get(0).play();
        videos.css({'visibility':'visible', 'opacity':'1'});
    }
}

/**
 * toggleSwiperCaptionAnimation
 * @description  toggle swiper animations on active slides
 */
function toggleSwiperCaptionAnimation(swiper) {
    var prevSlide = $(swiper.container).find("[data-caption-animate]"),
        nextSlide = $(swiper.slides[swiper.activeIndex]).find("[data-caption-animate]"),
        delay,
        duration,
        nextSlideItem,
        prevSlideItem;

    for (var i = 0; i < prevSlide.length; i++) {
        prevSlideItem = $(prevSlide[i]);

        prevSlideItem.removeClass("animated")
            .removeClass(prevSlideItem.attr("data-caption-animate"))
            .addClass("not-animated");
    }

    for (var i = 0; i < nextSlide.length; i++) {
        nextSlideItem = $(nextSlide[i]);
        delay = nextSlideItem.attr("data-caption-delay");
        duration = nextSlideItem.attr('data-caption-duration');

        var tempFunction = function (nextSlideItem, duration) {
            return function(){
                nextSlideItem
                    .removeClass("not-animated")
                    .addClass(nextSlideItem.attr("data-caption-animate"))
                    .addClass("animated");

                if (duration) {
                    nextSlideItem.css('animation-duration', duration + 'ms');
                }
            };
        };

        setTimeout(tempFunction(nextSlideItem, duration), delay ? parseInt(delay, 10) : 0);
    }
}

/**
 * makeWaypointScroll
 * @description  init smooth anchor animations
 */
function makeWaypointScroll(obj) {
    var $this = $(obj);
    $this.on('click', function (e) {
        e.preventDefault();
        $("body, html").stop().animate({
            scrollTop: $("#" + $(this).attr('data-custom-scroll-to')).offset().top
        }, 1000, function () {
            $window.trigger("resize");
        });
    });
}

/**
 * initSwiperWaypoints
 * @description  toggle waypoints on active slides
 */
function initSwiperWaypoints(swiper) {
    var prevSlide = $(swiper.container),
        nextSlide = $(swiper.slides[swiper.activeIndex]);

    prevSlide
        .find('[data-custom-scroll-to]')
        .each(function () {
            var $this = $(this);
            makeWaypointScroll($this);
        });

    nextSlide
        .find('[data-custom-scroll-to]')
        .each(function () {
            var $this = $(this);
            makeWaypointScroll($this);
        });
}

    var s = $(".swiper-slider");
    var pag = s.find(".swiper-pagination"),
        next = s.find(".swiper-button-next"),
        prev = s.find(".swiper-button-prev"),
        bar = s.find(".swiper-scrollbar"),
        parallax = s.parents('.rd-parallax').length,
        swiperSlide = s.find(".swiper-slide"),
        autoplay = false;

    for (var j = 0; j < swiperSlide.length; j++) {
        var $this = $(swiperSlide[j]),
            url;

        if (url = $this.attr("data-slide-bg")) {
            $this.css({
                "background-image": "url(" + url + ")",
                "background-size": "cover"
            })
        }
    }


    swiperSlide.end()
        .find("[data-caption-animate]")
        .addClass("not-animated")
        .end()
        .swiper({
            noSwipingClass:true,
            preventClicks: false,
            preventClicksPropagation: false,
            autoplay: s.attr('data-autoplay') ? s.attr('data-autoplay') === "false" ? undefined : s.attr('data-autoplay') : 5000,
            direction: s.attr('data-direction') ? s.attr('data-direction') : "horizontal",
            effect: s.attr('data-slide-effect') ? s.attr('data-slide-effect') : "slide",
            speed: s.attr('data-slide-speed') ? s.attr('data-slide-speed') : 600,
            keyboardControl: s.attr('data-keyboard') === "true",
            mousewheelControl: s.attr('data-mousewheel') === "true",
            mousewheelReleaseOnEdges: s.attr('data-mousewheel-release') === "true",
            nextButton: next.length ? next.get(0) : null,
            prevButton: prev.length ? prev.get(0) : null,
            pagination: pag.length ? pag.get(0) : null,
            paginationClickable: pag.length ? pag.attr("data-clickable") !== "false" : false,
            paginationBulletRender: pag.length ? pag.attr("data-index-bullet") === "true" ? function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            } : null : null,
            scrollbar: bar.length ? bar.get(0) : null,
            scrollbarDraggable: bar.length ? bar.attr("data-draggable") !== "false" : true,
            scrollbarHide: bar.length ? bar.attr("data-draggable") === "false" : false,
            loop: s.attr('data-loop') !== "false",
            simulateTouch: s.attr('data-simulate-touch') ? s.attr('data-simulate-touch') === "true" : false,
            onTransitionStart: function (swiper) {
                toggleSwiperInnerVideos(swiper);
            },
            onTransitionEnd: function (swiper) {
                toggleSwiperCaptionAnimation(swiper);
            },
            onInit: function (swiper) {
                toggleSwiperInnerVideos(swiper);
                toggleSwiperCaptionAnimation(swiper);
                // initSwiperCustomParallax(swiper);
                initSwiperWaypoints(swiper);
                $(window).on('resize', function () {
                    swiper.update(true);
                })

                if(!isRtl) {
                    $window.on('resize', function () {
                        swiper.update(true);
                    });
                }

                //initLightGallery($('[data-lightgallery="group-swiper"]'), 'lightGallery-in-carousel');
                //initLightGalleryItem($('[data-lightgallery="item-swiper"]'), 'lightGallery-in-carousel');
            }
        });

    $(window).on("resize", function () {
            var mh = getSwiperHeight(s, "min-height"),
                h = getSwiperHeight(s, "height");
            if (h) {
                s.css("height", mh ? mh > h ? mh : h : h);
            }
    }).trigger("resize");

    var userAgent = navigator.userAgent.toLowerCase(),
        isDesktop = $html.hasClass("desktop"),
        isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
        isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    var isIE = userAgent.indexOf("msie") != -1 ? parseInt(userAgent.split("msie")[1]) : userAgent.indexOf("trident") != -1 ? 11 : userAgent.indexOf("edge") != -1 ? 12 : false;

    var materialParallax = $(".parallax-container");

    if(materialParallax.length)
    {
        if (!isIE && !isMobile) {
            materialParallax.parallax();

            // heavy pages fix
            $window.on('load', function () {
                setTimeout(function () {
                    $window.scroll();
                }, 500);
            });
        } else {
            for (var i = 0; i < materialParallax.length; i++) {
                var parallax = $(materialParallax[i]),
                    imgPath = parallax.data("parallax-img");

                parallax.css({
                    "background-image": 'url(' + imgPath + ')',
                    "background-size": "cover"
                });
            }
        }
    }

    $(document).ready(function(){

        $('.swiper-slide a').click(function() { window.location.href = $(this).attr("href"); });

        $(document).on('click','.js-accept-cookies',function(e) {
            e.preventDefault();

            //1 year
            api.setCookie('cookies_accept',Date.now(), 8760);

            if($('#statistics_cookies').prop('checked'))
            {
                api.setCookie('cookies_statistics_accepted',Date.now(), 8760);
            }

            $('.cookies-accept').fadeOut();
        });

        var isotope = $(".isotope");

        if (isotope.length) {
            var isogroup = [];
            for (var i = 0; i < isotope.length; i++) {
                var isotopeItem = isotope[i],
                    isotopeInitAttrs = {
                        itemSelector: '.isotope-item',
                        layoutMode: isotopeItem.getAttribute('data-isotope-layout') ? isotopeItem.getAttribute('data-isotope-layout') : 'masonry',
                        filter: '*'
                    };

                if (isotopeItem.getAttribute('data-column-width')) {
                    isotopeInitAttrs.masonry = {
                        columnWidth: parseFloat(isotopeItem.getAttribute('data-column-width'))
                    };
                } else if (isotopeItem.getAttribute('data-column-class')) {
                    isotopeInitAttrs.masonry = {
                        columnWidth: isotopeItem.getAttribute('data-column-class')
                    };
                }

                var iso = new Isotope(isotopeItem, isotopeInitAttrs);
                isogroup.push(iso);
            }


            setTimeout(function () {
                for (var i = 0; i < isogroup.length; i++) {
                    isogroup[i].element.className += " isotope--loaded";
                    isogroup[i].layout();
                }
            }, 200);

            var resizeTimout;

            $("[data-isotope-filter]").on("click", function (e) {
                e.preventDefault();
                var filter = $(this);
                clearTimeout(resizeTimout);
                filter.parents(".isotope-filters").find('.active').removeClass("active");
                filter.addClass("active");
                var iso = $('.isotope[data-isotope-group="' + this.getAttribute("data-isotope-group") + '"]'),
                    isotopeAttrs = {
                        itemSelector: '.isotope-item',
                        layoutMode: iso.attr('data-isotope-layout') ? iso.attr('data-isotope-layout') : 'masonry',
                        filter: this.getAttribute("data-isotope-filter") === '*' ? '*' : '[data-filter*="' + this.getAttribute("data-isotope-filter") + '"]'
                    };
                if (iso.attr('data-column-width')) {
                    isotopeAttrs.masonry = {
                        columnWidth: parseFloat(iso.attr('data-column-width'))
                    };
                } else if (iso.attr('data-column-class')) {
                    isotopeAttrs.masonry = {
                        columnWidth: iso.attr('data-column-class')
                    };
                }
                iso.isotope(isotopeAttrs);
            }).eq(0).trigger("click")
        }


        /**
         * @desc Initialize the gallery with set of images
         * @param {object} itemsToInit - jQuery object
         * @param {string} addClass - additional gallery class
         */
        function initLightGallery(itemsToInit, addClass) {
            $(itemsToInit).lightGallery({
                thumbnail: $(itemsToInit).attr("data-lg-thumbnail") !== "false",
                selector: "[data-lightgallery='item']",
                autoplay: $(itemsToInit).attr("data-lg-autoplay") === "true",
                pause: parseInt($(itemsToInit).attr("data-lg-autoplay-delay")) || 5000,
                addClass: addClass,
                mode: $(itemsToInit).attr("data-lg-animation") || "lg-slide",
                loop: $(itemsToInit).attr("data-lg-loop") !== "false",
                download: false
            });
        }

        /**
         * @desc Initialize the gallery with dynamic addition of images
         * @param {object} itemsToInit - jQuery object
         * @param {string} addClass - additional gallery class
         */
        function initDynamicLightGallery(itemsToInit, addClass) {
            $(itemsToInit).on("click", function () {
                $(itemsToInit).lightGallery({
                    thumbnail: $(itemsToInit).attr("data-lg-thumbnail") !== "false",
                    download: false,
                    selector: "[data-lightgallery='item']",
                    autoplay: $(itemsToInit).attr("data-lg-autoplay") === "true",
                    pause: parseInt($(itemsToInit).attr("data-lg-autoplay-delay")) || 5000,
                    addClass: addClass,
                    mode: $(itemsToInit).attr("data-lg-animation") || "lg-slide",
                    loop: $(itemsToInit).attr("data-lg-loop") !== "false",
                    dynamic: true,
                    dynamicEl: JSON.parse($(itemsToInit).attr("data-lg-dynamic-elements")) || []
                });
            });
        }

        /**
         * @desc Initialize the gallery with one image
         * @param {object} itemToInit - jQuery object
         * @param {string} addClass - additional gallery class
         */
        function initLightGalleryItem(itemToInit, addClass) {
            $(itemToInit).lightGallery({
                selector: "this",
                addClass: addClass,
                counter: false,
                youtubePlayerParams: {
                    modestbranding: 1,
                    showinfo: 0,
                    rel: 0,
                    controls: 0
                },
                vimeoPlayerParams: {
                    byline: 0,
                    portrait: 0
                }
            });
        }

        var lightGallery = $("[data-lightgallery='group']");
        var lightGalleryItem = $("[data-lightgallery='item']");
        var lightDynamicGalleryItem = $("[data-lightgallery='dynamic']");

        // lightGallery
        if (lightGallery.length) {
            for (var i = 0; i < lightGallery.length; i++) {
                initLightGallery(lightGallery[i]);
            }
        }

        // lightGallery item
        if (lightGalleryItem.length) {
            // Filter carousel items
            var notCarouselItems = [];

            for (var z = 0; z < lightGalleryItem.length; z++) {
                if (!$(lightGalleryItem[z]).parents('.owl-carousel').length && !$(lightGalleryItem[z]).parents('.swiper-slider').length && !$(lightGalleryItem[z]).parents('.slick-slider').length) {
                    notCarouselItems.push(lightGalleryItem[z]);
                }
            }

            lightGalleryItem = notCarouselItems;

            for (var i = 0; i < lightGalleryItem.length; i++) {
                initLightGalleryItem(lightGalleryItem[i]);
            }
        }

        // Dynamic lightGallery
        if (lightDynamicGalleryItem.length) {
            for (var i = 0; i < lightDynamicGalleryItem.length; i++) {
                initDynamicLightGallery(lightDynamicGalleryItem[i]);
            }
        }
    });
